import React from 'react';
import { SimpleBarContext } from 'routes/surface/components/simplebar';
import useEventListener from 'hooks/use-event-listener';

export default function useOnTextEditorScroll(callBack: Function) {
  const simpleBarContext = React.useContext(SimpleBarContext);

  const element = simpleBarContext?.getSimpleBar()?.contentWrapperEl;

  function onScrollHandler() {
    callBack();
  }

  useEventListener('scroll', onScrollHandler, element);
}
